export default "__VITE_ASSET__B8CHbE7m__"